export const sessionStorageKey = {
  passwordResetEmail: 'password-reset-email',
};
